import React, { useLayoutEffect} from "react";
import { useMedia } from "use-media";
import logo from "../../resources/icons/logo_reservations.svg";
import { Label } from "../atoms/label";
import { Link } from "../atoms/link";
import { useHistory } from "react-router-dom";
import { useStore } from "react-redux";

export const GolfHeaderContainer = (props) => {
  const { onClickOpenReservationPopupWindow, setPathSetLoading } = props;
  const isWideTablet = useMedia({ maxWidth: "960px" });
  const history = useHistory();
  const store = useStore();
  const prevScreenInfo = store.getState().prevScreenInfo;

  // ページ遷移管理処理
  useLayoutEffect(() => {
    store.dispatch({ type:"PREV_SCREEN_INFO", payload: { prevScreenInfo: {currentPath: history.location.pathname , prevPath: prevScreenInfo.currentPath}} });
    if(setPathSetLoading){
      setPathSetLoading(false);
    }
  },[])

  const onClickBack = () => {
    if(props.reserveDetailFlg){
      history.push(props.path,{locationFlg: true });
    }else{
      history.push(props.path);
    }
  };
  const onClickIcon = () => {
    if(props.confirmCheck === undefined || props.reserveCheck){
      history.push("/reserve/top");
    }
  };
  const login = store.getState().login;

  return (
    <div>
      <div style={isWideTablet ? styles.headerBaseSp : styles.headerBasePc}>
        <img onClick={onClickIcon} src={logo} style={isWideTablet ? styles.headerBaseLeftImgSp : styles.headerBaseLeftImgPc} />
        {props.confirmCheck === undefined && props.reserveCheck === undefined ?
          <>
            <div className="headerBaseRight" tabIndex={props.tabIndex}>
              <Link linkTitle="＞予約内容の確認・変更・キャンセルはこちら" style={styles.linkLabel} onClick={() => onClickOpenReservationPopupWindow(login.memberCode)} />
            </div>
          </>
        : null
        }
      </div>
      <div style={isWideTablet ? styles.headerBaseSp : styles.headerBasePc}>
        <div style={isWideTablet ? styles.headerBaseCenterSp : styles.headerBaseCenter}>
          {isWideTablet && props.path ?
          <div style={{position:"absolute",left:40,top:"29%",justifyContent:"center"}} onClick={onClickBack}>＜</div>
          :null}
          <div style={{display:"flex", justifyContent:"center",width:"100%", padding:"0px 0px 8px"}}>
            <div>
              <Label label={props.categoryLabel1} style={isWideTablet ? styles.spLabelStyle1 : styles.pcLabelStyle1} />
              <Label label={props.categoryLabel2} style={isWideTablet ? styles.spLabelStyle2 : styles.pcLabelStyle2} />
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  headerBasePc: {
    background: "White",
    padding: "0rem 0px 0px 0rem",
    display: "table",
    width: "100%",
    height: "0rem",
    boxSizing: "border-box",
    letterSpacing: "0.3rem",
  },

  headerBaseSp: {
    background: "White",
    display: "table",
    width: "100%",
    height: ".5rem",
    padding: "0px 0px 8px",
    verticalAlign: "middle",
    boxSizing: "border-box",

  },

  headerBaseLeftImgSp: {
    height: "1rem",
    margin: "1rem 0 0 1rem",
    width: "35%",
    boxSizing: "border-box",
  },
  headerBaseLeftImgPc: {
    height: "1rem",
    margin: "1rem 0px 0.5rem 1rem",
    maxWidth: "100%",
    boxSizing: "border-box",
  },
  headerBaseRightLogout: {
    float: "right",
    marginTop: "0.7rem",
    marginRight: "0.7rem",
    letterSpacing: "0.05rem",
    fontWeight: 500,
  },
  headerBaseCenter: {
    display: "table-cell",
    width: "100%",
    margin: "0px auto",
    verticalAlign: "middle",
    boxSizing: "border-box",
    borderTop: "solid 1px",
    borderColor: "#eee",
  },
  headerBaseCenterSp: {
    display: "flex",
    width: "100%",
    margin: "0px auto",
    verticalAlign: "middle",
    boxSizing: "border-box",
    borderTop: "solid 1px",
    position:"relative",
    borderColor: "#eee",
  },

  headerLogout: {
    textDecoration: 'none',
    fontSize: "12px",
    textAlign: "center",
  },

  spLabelStyle1: {
    width: "100%",
    fontSize: "1rem",
    margin: "0 auto",
    marginTop: "20px",
    color: "black",
    textAlign: "center",
    letterSpacing: "0.2rem",
    fontWeight: "bold",
  },

  spLabelStyle2: {
    width: "100%",
    fontSize: "0.5rem",
    textAlign: "center",
    marginBottom: "1rem",
    color: "#707070",
    letterSpacing: ".3rem",
  },


  pcLabelStyle1: {
    width: "100%",
    fontSize: "1.5rem",
    margin: "0 auto",
    color: "black",
    textAlign: "center",
    letterSpacing: "0.2rem",
    marginTop: "1.5rem",
    fontWeight: "bold",
  },

  pcLabelStyle2: {
    width: "100%",
    fontSize: "0.8rem",
    textAlign: "center",
    marginBottom: "1.5rem",
    color: "#707070",
  },

  linkLabel: {
    cursor: "pointer",
    height: "16px",
  },
};
